<p-card styleClass="h-full p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center">
      <h2>Verse of the Day</h2>
      <i class="fas fa-bible text-blue-500 text-lg"></i>
    </div>
  </ng-template>
  
  <div class="flex flex-col h-full">
    <!-- Loading State -->
    <div *ngIf="isLoading()" class="flex justify-center items-center h-48">
      <div class="flex flex-col items-center gap-3">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <p class="text-gray-500 text-sm">Loading today's verse...</p>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="hasError() && !isLoading()" class="flex flex-col items-center justify-center h-48 text-center">
      <div class="flex flex-col items-center gap-3">
        <i class="fas fa-exclamation-triangle text-red-500 text-2xl"></i>
        <p class="text-gray-700 font-medium">Unable to load verse</p>
        <p class="text-gray-500 text-sm">{{ errorMessage() }}</p>
        <button 
          pButton 
          type="button" 
          label="Retry" 
          icon="fas fa-redo"
          class="p-button-sm p-button-outlined"
          (click)="retry()">
        </button>
      </div>
    </div>

    <!-- Content State -->
    <div *ngIf="!isLoading() && !hasError() && verse()" class="flex flex-col h-full">
      <!-- Verse Reference -->
      <div class="mb-4">
        <h3 class="text-lg font-semibold text-gray-800 italic">
          {{ getVerseReference() }}
        </h3>
      </div>

      <!-- Verse Content -->
      <div class="flex-1">
        <div class="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
          <div 
            class="text-gray-700 leading-relaxed eb-container scripture-content"
            [innerHTML]="getVerseContent()">
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="mt-4 pt-3 border-t border-gray-200">
        <div class="flex justify-between items-center text-xs text-gray-500">
          <span>Powered by API.Bible</span>
          <span>{{ getCurrentDate() | date:'MMM d, y' }}</span>
        </div>
      </div>
    </div>

    <!-- No API Key State -->
    <div *ngIf="!isLoading() && !hasError() && !verse()" class="flex flex-col items-center justify-center h-48 text-center">
      <div class="flex flex-col items-center gap-3">
        <i class="fas fa-key text-yellow-500 text-2xl"></i>
        <p class="text-gray-700 font-medium">API Key Required</p>
        <p class="text-gray-500 text-sm">Please configure the API key to display verses</p>
      </div>
    </div>
  </div>
</p-card>
